
// package imports
import { toJS } from "mobx";
import moment from "moment";

import AuthStore from "modules/login/store/AuthStore";
import FamilyMemberTypeEnum from 'modules/family-details-form/FamilymemberTypeEnum'
import ProductConstants from "constants/ProductConstants";
import { EMPLOYER_EMPLOYEE_SCHEME_A, HUF, INDIVIDUAL, KEYMAN, PARTNERSHIP } from "constants/ CustomerType";
import utils from "./utils";

const initialDefaults = (formRef, data) => {
    let productName = data.productName
    let requestData = data.data.bi_request
    let ppf = requestData.INPUT_MODE?.toString();
    let sopp = requestData.SOURCE_OF_PP?.toString();
    let prn_number = requestData.PRAN_NUMBER?.toString();
    let annuity_benefit = requestData?.AnnuityBenefit?.toString();
    let life_status = requestData.LifeStatus?.toString();
    let annuity_mode = requestData?.AnnuityMode?.toString();
    let purchase_Price_amount = requestData.ModalPremium?.toString();
    let deferment_period = requestData.DefermentPeriod?.toString();
    let annuity_option = requestData.AnnuityOption?.toString();
    let secondary_annuitant_name = requestData.NameoftheSecondaryAnnuitant?.toString();
    let secondary_annuitant_date_of_birth = requestData.SecondaryAnnuitantDateofbirth;
    let secondary_annuitant_gender = requestData.SecondaryAnnuitantGender?.toString();
    let SecondaryAnnuitantDOB = requestData.SecondaryAnnuitantDOB
    let premium_amount = requestData.PR_ANNPREM == 0 ? data?.data?.firstYearResponse?.MODAL_PREM : requestData.PR_ANNPREM;
    let income = requestData.investment_target?.toString();
    let journeyData = toJS(AuthStore.journeyData);
    let familyMemberType = data.data.family_member_type
    let ppt = requestData.PR_PPT?.toString();
    let pt = requestData.PR_PT?.toString();
    let accrualOfSurvivalBenefits = requestData?.AccrualOfSurvivalBenefit_1
    let accrualOfSurvivalBenefit_2 = requestData?.AccrualOfSurvivalBenefit_2
    let accrualOfSurvivalBenefit_3 = requestData?.AccrualOfSurvivalBenefit_3
    let asbStartYearOne = requestData?.ASB_StartPolicyYear_1
    let asbEndYearOne = requestData?.ASB_EndPolicyYear_1
    let asbStartYearTwo = requestData?.ASB_StartPolicyYear_2
    let asbEndYearTwo = requestData?.ASB_EndPolicyYear_2
    let asbStartYearThree = requestData?.ASB_StartPolicyYear_3
    let asbEndYearThree = requestData?.ASB_EndPolicyYear_3
    let WithdrawalPercentageOne = requestData?.WithdrawalPercentage_1
    let WithdrawalPercentageTwo = requestData?.WithdrawalPercentage_2
    let WithdrawalPercentageThree = requestData?.WithdrawalPercentage_3
    let liAge = Number(requestData.LI_ENTRY_AGE)
    let pt_value = requestData.PT_VALUE
    let annuityOptionBasis = requestData?.AnnuityOptionBasis

    let defermentAndLiAge = Number(deferment_period) + liAge + 1

    let genderList = { "Male": '8', "Female": '9' }

    let validJourneyTypes = [EMPLOYER_EMPLOYEE_SCHEME_A, HUF, PARTNERSHIP, KEYMAN];

    formRef.$('premium-term').set('value', { id: ppt, label: ppt })


    formRef.$('policy-term').set('value', { label: "-", id: pt })
    // let ptList = [
    //     { label: 'Upte Age 100', id: 0 },
    // ]
    // formRef.$('policy-term').set('extra', { ...formRef.$('policy-term').extra, optionList: ptList })


    switch (familyMemberType) {

        case 'SELF':
            let spouseDetail = journeyData.family_details_list.find(item => item.family_member_type === FamilyMemberTypeEnum.SPOUSE)

            if (spouseDetail) {
                secondary_annuitant_name = spouseDetail.middle_name ? `${spouseDetail.first_name} ${spouseDetail.middle_name} ${spouseDetail.last_name}` : `${spouseDetail.first_name} ${spouseDetail.last_name}`

                secondary_annuitant_date_of_birth = spouseDetail.dob

                secondary_annuitant_gender = genderList[spouseDetail.gender]
            }

            break;

        case 'SPOUSE':
            let selfDetail = journeyData.family_details_list.find(item => item.family_member_type === FamilyMemberTypeEnum.SELF)

            if (selfDetail) {
                secondary_annuitant_name = selfDetail.middle_name ? `${selfDetail.first_name} ${selfDetail.middle_name} ${selfDetail.last_name}` : `${selfDetail.first_name} ${selfDetail.last_name}`

                secondary_annuitant_date_of_birth = selfDetail.dob

                secondary_annuitant_gender = genderList[selfDetail.gender]
            }

            break;

        case 'GRAND_FATHER':
            let grandMotherDetail = journeyData.family_details_list.find(item => item.family_member_type === FamilyMemberTypeEnum.GRAND_MOTHER)

            if (grandMotherDetail) {
                secondary_annuitant_name = grandMotherDetail.middle_name ? `${grandMotherDetail.first_name} ${grandMotherDetail.middle_name} ${grandMotherDetail.last_name}` : `${grandMotherDetail.first_name} ${grandMotherDetail.last_name}`

                secondary_annuitant_date_of_birth = grandMotherDetail.dob

                secondary_annuitant_gender = genderList[grandMotherDetail.gender]
            }

            break;

        case 'GRAND_MOTHER':
            let grandFatherDetail = journeyData.family_details_list.find(item => item.family_member_type === FamilyMemberTypeEnum.GRAND_MOTHER)

            if (grandFatherDetail) {
                secondary_annuitant_name = grandFatherDetail.middle_name ? `${grandFatherDetail.first_name} ${grandFatherDetail.middle_name} ${grandFatherDetail.last_name}` : `${grandFatherDetail.first_name} ${grandFatherDetail.last_name}`

                secondary_annuitant_date_of_birth = grandFatherDetail.dob

                secondary_annuitant_gender = genderList[grandFatherDetail.gender]
            }

            break;

        default:
            break;
    }

    // ! payment-frequency:
    if (ppt === "1") {
        formRef.$("payment-frequency").set("extra", {
            ...formRef.$("payment-frequency").extra,
            options: [
                { label: "Single", id: "5" }
            ],
        });

        formRef.$("annuity-benefit").set("extra", {
            ...formRef.$("annuity-benefit").extra,
            options: [
                { label: "Immediate Annuity", id: "1" },
                { label: "Deferred Income", id: "2" },
            ],
        });
    }


    switch (ppf) {
        case '1':
            formRef.$('payment-frequency').set('value', { label: "Annual", id: '1' })
            break;
        case '2':
            formRef.$('payment-frequency').set('value', { label: "Semi-Annual", id: '2' })
            break;
        case '3':
            formRef.$('payment-frequency').set('value', { label: "Quarterly", id: '3' })
            break;
        case '4':
            formRef.$('payment-frequency').set('value', { label: "Monthly", id: '4' })
            break;
        case '5':
            formRef.$('payment-frequency').set('value', { label: "Single", id: '5' })
            break;
        default:
            break;
    }


    // ! source-of-purchase-price:

    switch (sopp) {
        case '1':
            formRef.$('source-of-purchase-price').set('value', { label: 'Open Market', id: '1' })

            formRef.$("pran-number").set("extra", {
                ...formRef.$("pran-number").extra,
                visible: false,
            });
            break;
        case '2':
            formRef.$('source-of-purchase-price').set('value', { label: "Proceeds of pension policy of ETLI Co Ltd", id: "2" })
            break;
        case '3':
            formRef.$('source-of-purchase-price').set('value', { label: "Proceeds of pension policy of other Insurer", id: "3" })
            break;
        case '4':
            formRef.$('source-of-purchase-price').set('value', { label: "Proceeds of NPS (National Pension Scheme )", id: "4" })

            formRef.$("pran-number").set("extra", {
                ...formRef.$("pran-number").extra,
                visible: true,
            });
            break;

        default:
            break;
    }

    // ! pran-number
    formRef.$('pran-number').set('value', prn_number)

    // ! annuity-benefit


    // if (ProductConstants.FOREVER_PENSION_DEFERRED_ANNUITY || ProductConstants.FOREVER_PENSION_IMMEDIATE_ANNUITY) {
    //     formRef.$('annuity-benefit').set('disabled', true)
    // }
    // formRef.$('annuity-benefit').set('disabled', true)

    switch (annuity_benefit) {
        case '1':
            formRef.$('annuity-benefit').set('value', { label: "Immediate Annuity", id: '1' })
            break;
        case '2':
            formRef.$('annuity-benefit').set('value', { label: "Deferred Income", id: '2' })
            break;
        default:
            break;
    }

    // ! life-status

    switch (life_status) {
        case '3':
            formRef.$('life-status').set('value', { label: "Single Life", id: '3' })
            break;
        case '4':
            formRef.$('life-status').set('value', { label: "Joint Life", id: '4' })
            break;
        default:
            break;
    }

    // ! annuity-mode

    switch (annuity_mode) {
        case '21':
            formRef.$('annuity-mode').set('value', { label: "Yearly", id: '21' })
            break;
        case '22':
            formRef.$('annuity-mode').set('value', { label: "Half-Yearly", id: '22' })
            break;
        case '23':
            formRef.$('annuity-mode').set('value', { label: "Quarterly", id: '23' })
            break;
        case '24':
            formRef.$('annuity-mode').set('value', { label: "Monthly", id: '24' })
            break;
        default:
            break;
    }

    switch (annuityOptionBasis) {
        case "3":
            formRef.$('annuity-option-basis').set('value', { label: "Single Life", id: '3' })
            break;

        case "4":
            formRef.$('annuity-option-basis').set('value', { label: "Joint Life", id: '4' })
            break;

        default:
            break;
    }

    // ! purchase-Price-amount
    formRef.$('purchase-Price-amount').set('value', purchase_Price_amount)

    // ! deferment-period
    let defermentPeiodList = utils.defermentPeriodOptionList(ppt, annuity_option)

    let defermentPeriodValue = utils.defermentPeriodList(deferment_period)

    formRef.$("deferment-period").set("value", defermentPeriodValue)
    formRef.$("deferment-period").set("extra", {
        ...formRef.$("deferment-period").extra,
        options: defermentPeiodList,
    });

    if (annuity_benefit === '1') {
        formRef.$("deferment-period").set("value", { label: "0", id: "9" })
        formRef.$("deferment-period").set("disabled", true)
    }



    if (productName === ProductConstants.FOREVER_PENSION_DEFERRED_ANNUITY) {
        formRef.$('deferment-period').set('disabled', false)
    }

    // ! annuity-option
    // Single Life
    let annuityOptionList = utils.annuityOptionList(annuity_benefit, liAge)
    //! annuity option set list
    //! Single Life set list
    // if (Number(annuity_option) === 1 || Number(annuity_option) === 2) {
    //     if (Number(liAge) > 70 && Number(liAge) <= 80) {
    //         annuityOptionList = [
    //             {
    //                 label:
    //                     "Deferred Annuity with Return of Purchase Price on Death (Single life)",
    //                 id: "2",
    //             },
    //         ]
    //     } else {
    //         annuityOptionList = [
    //             { label: "Deferred Life Annuity" , id: "1" },
    //             {
    //                 label:
    //                     "Deferred Annuity with Return of Purchase Price on Death (Single life)",
    //                 id: "2",
    //             }
    //         ]
    //     }
    // } else {
    //     annuityOptionList = [
    //         // {
    //         //     label:
    //         //         "Deferred Annuity with Return of Purchase Price on Death (Joint Life, Last Survivor)",
    //         //     id: "3",
    //         // }
    //     ]
    // }

    formRef.$("annuity-option").set("extra", {
        ...formRef.$("annuity-option").extra,
        options: [...annuityOptionList],
    });

    switch (annuity_option) {
        case '5':
            formRef.$('annuity-option').set('value', { label: "Immediate Life Annuity", id: "5" })
            break;
        case '6':
            formRef.$('annuity-option').set('value', { label: "Immediate Life Annuity with Return of Purchase Price on Death", id: "6" })
            break;
        case '7':
            formRef.$('annuity-option').set('value', { label: "Deferred Life Annuity", id: "7" })
            break;
        case '8':
            formRef.$('annuity-option').set('value', { label: "Deferred Life Annuity with Return of Purchase Price", id: "8" })
            break;
        default:
            break;
    }

    // ! secondary-annuitant-name
    formRef.$('secondary-annuitant-name').set('value', secondary_annuitant_name)

    // ! secondary-annuitant-date-of-birth
    formRef.$('secondary-annuitant-date-of-birth').set('value', SecondaryAnnuitantDOB)
    // ! secondary-annuitant-gender
    switch (secondary_annuitant_gender) {
        case '19':
            formRef.$('secondary-annuitant-gender').set('value', { label: "Male", id: '19' })
            break;
        case '20':
            formRef.$('secondary-annuitant-gender').set('value', { label: "Female", id: '20' })
            break;
        default:
            break;
    }

    // ! disabling Name of the Secondary Annuitant, DOB of the Secondary Annuitant, Gender of the Secondary Annuitant
    // formRef.$("secondary-annuitant-name").set("disabled", true)
    // formRef.$("secondary-annuitant-date-of-birth").set("disabled", true);
    // formRef.$("secondary-annuitant-gender").set("disabled", true);
    if (annuityOptionBasis === "3") {
        //! for diabling the fields
        formRef.$("secondary-annuitant-name").set("disabled", true)
        formRef.$("secondary-annuitant-date-of-birth").set("disabled", true);
        formRef.$("secondary-annuitant-gender").set("disabled", true);

        //! for setting the values of the to null
        formRef.$('secondary-annuitant-name').set('value', '');
        formRef.$("secondary-annuitant-date-of-birth").set("value", "");
        formRef.$("secondary-annuitant-gender").set("value", "");
    }

    // ! premium-amount
    formRef.$('premium-amt').set('value', premium_amount)

    // ! income
    formRef.$('income').set('value', income)


    // !Accrual Of Survival Benefits
    switch (Number(accrualOfSurvivalBenefits)) {
        case 25:
            formRef.$('accrual-of-survival-benefit').set('value', { label: 'No', id: "25" })
            break;
        case 24:
            formRef.$('accrual-of-survival-benefit').set('value', { label: 'Yes', id: "24" })
            break;
        default:
            break;
    }

    // formRef.$("accrual-of-survival-benefits").set("disabled", true);
    utils.handleAsbCondition(formRef, accrualOfSurvivalBenefits)
    // Initial value of ASB Start year 1

    let asbStartYearOneList = utils.fetchASBstartPolicyOne(pt_value, ppt, formRef.$("asb-start-age-(1st-opt-in)").extra.preDefinedOptList, defermentAndLiAge)
    formRef.$("asb-start-age-(1st-opt-in)").set("extra", {
        ...formRef.$("asb-start-age-(1st-opt-in)").extra,
        optionList: asbStartYearOneList,
    });


    let asbStartYearOneOpt = asbStartYearOneList.filter((item) => Number(asbStartYearOne) === item.id)
    if (asbStartYearOneOpt.length > 0) formRef.$("asb-start-age-(1st-opt-in)").set("value", asbStartYearOneOpt[0])

    // Initial value of ASB End year 1
    let asbEndYearOneList = utils.fetchASBendPolicyOne(formRef.$("asb-start-age-(1st-opt-in)").value.id, asbStartYearOneList, formRef.$("asb-end-age-(1st-opt-in)").extra.preDefinedOptList)
    formRef.$("asb-end-age-(1st-opt-in)").set("extra", {
        ...formRef.$("asb-end-age-(1st-opt-in)").extra,
        optionList: asbEndYearOneList,
    });
    let asbEndYearOneOpt = asbEndYearOneList.filter((item) => Number(asbEndYearOne) === Number(item.id))
    if (asbEndYearOneOpt.length > 0) formRef.$("asb-end-age-(1st-opt-in)").set("value", asbEndYearOneOpt[0])

    let asbWithDrawalParcentage1 = formRef.$("withdrawal-parcentage-1").extra.preDefinedOptList
    formRef.$("withdrawal-parcentage-1").set("extra", {
        ...formRef.$("withdrawal-parcentage-1").extra,
        optionList: asbWithDrawalParcentage1,
    });

    let withdrawalPercentage1 = asbWithDrawalParcentage1.filter((item) => Number(WithdrawalPercentageOne) === Number(item.id))
    if (withdrawalPercentage1.length > 0) formRef.$("withdrawal-parcentage-1").set("value", withdrawalPercentage1[0])

    switch (Number(accrualOfSurvivalBenefit_2)) {
        case 329:
            formRef.$("accrual-of-survival-benefits-year-2").set("value", {
                id: accrualOfSurvivalBenefit_2,
                label: 'Yes',
            });
            break;

        case 330:
            formRef.$("accrual-of-survival-benefits-year-2").set("value", {
                id: accrualOfSurvivalBenefit_2,
                label: 'No',
            });
            break;

        default:
            break;
    }
    utils.handleAsbTwoCondition(formRef, accrualOfSurvivalBenefit_2)

    // Initial value of ASB Start year 2
    let asbTwoStartYearOneList = utils.fetchASBendPolicyOne(
        formRef.$("asb-end-age-(1st-opt-in)").value.id + 1,
        formRef.$("asb-end-age-(1st-opt-in)").extra.optionList,
        formRef.$("asb-start-age-(2nd-opt-in)").extra.preDefinedOptList
    );
    formRef.$("asb-start-age-(2nd-opt-in)").set("extra", {
        ...formRef.$("asb-start-age-(2nd-opt-in)").extra,
        optionList: asbTwoStartYearOneList,
    });
    let asbTwoStartYearOneOpt = asbTwoStartYearOneList.filter((item) => Number(asbStartYearTwo) === item.id)
    if (asbTwoStartYearOneOpt.length > 0) formRef.$("asb-start-age-(2nd-opt-in)").set("value", asbTwoStartYearOneOpt[0])

    // Initial value of ASB End year 2
    let asbTwoEndYearOneList = utils.fetchASBendPolicyOne(formRef.$("asb-start-age-(2nd-opt-in)").value.id, asbTwoStartYearOneList, formRef.$("asb-end-age-(2nd-opt-in)").extra.preDefinedOptList)
    formRef.$("asb-end-age-(2nd-opt-in)").set("extra", {
        ...formRef.$("asb-end-age-(2nd-opt-in)").extra,
        optionList: asbTwoEndYearOneList,
    });
    let asbTwoEndYearOneOpt = asbTwoEndYearOneList.filter((item) => Number(asbEndYearTwo) === item.id)
    if (asbTwoEndYearOneOpt.length > 0) formRef.$("asb-end-age-(2nd-opt-in)").set("value", asbTwoEndYearOneOpt[0])

    let asbWithDrawalParcentage2 = formRef.$("withdrawal-parcentage-2").extra.preDefinedOptList
    formRef.$("withdrawal-parcentage-2").set("extra", {
        ...formRef.$("withdrawal-parcentage-2").extra,
        optionList: asbWithDrawalParcentage2,
    });

    let withdrawalPercentage2 = asbWithDrawalParcentage2.filter((item) => Number(WithdrawalPercentageTwo) === Number(item.id))
    if (withdrawalPercentage2.length > 0) formRef.$("withdrawal-parcentage-2").set("value", withdrawalPercentage2[0])




    // Initial value of accrual of survival benefits 3
    switch (Number(accrualOfSurvivalBenefit_3)) {
        case 634:
            formRef.$("accrual-of-survival-benefits-year-3").set("value", {
                id: accrualOfSurvivalBenefit_3,
                label: 'Yes',
            });
            break;

        case 635:
            formRef.$("accrual-of-survival-benefits-year-3").set("value", {
                id: accrualOfSurvivalBenefit_3,
                label: 'No',
            });
            break;

        default:
            break;
    }
    utils.handleAsbThreeCondition(formRef, accrualOfSurvivalBenefit_3)

    // Initial value of ASB Start year 2
    let asbThreeStartYearOneList = utils.fetchASBendPolicyOne(
        formRef.$("asb-end-age-(2nd-opt-in)").value.id + 1,
        formRef.$("asb-end-age-(2nd-opt-in)").extra.optionList,
        formRef.$("asb-start-age-(3rd-opt-in)").extra.preDefinedOptList,
        defermentAndLiAge
    );
    formRef.$("asb-start-age-(3rd-opt-in)").set("extra", {
        ...formRef.$("asb-start-age-(3rd-opt-in)").extra,
        optionList: asbThreeStartYearOneList,
    });
    let asbThreeStartYearOneOpt = asbThreeStartYearOneList.filter((item) => Number(asbStartYearThree) === item.id)
    if (asbThreeStartYearOneOpt.length > 0) formRef.$("asb-start-age-(3rd-opt-in)").set("value", asbThreeStartYearOneOpt[0])

    // Initial value of ASB End year 2
    let asbThreeEndYearOneList = utils.fetchASBendPolicyOne(formRef.$("asb-start-age-(3rd-opt-in)").value.id, asbThreeStartYearOneList, formRef.$("asb-end-age-(3rd-opt-in)").extra.preDefinedOptList)
    formRef.$("asb-end-age-(3rd-opt-in)").set("extra", {
        ...formRef.$("asb-end-age-(3rd-opt-in)").extra,
        optionList: asbThreeEndYearOneList,
    });

    let asbThreeEndYearOneOpt = asbThreeEndYearOneList.filter((item) => Number(asbEndYearThree) === item.id)
    if (asbThreeEndYearOneOpt.length > 0) formRef.$("asb-end-age-(3rd-opt-in)").set("value", asbThreeEndYearOneOpt[0])

    let asbWithDrawalParcentage3 = formRef.$("withdrawal-parcentage-3").extra.preDefinedOptList
    formRef.$("withdrawal-parcentage-3").set("extra", {
        ...formRef.$("withdrawal-parcentage-3").extra,
        optionList: asbWithDrawalParcentage3,
    });

    let withdrawalPercentage3 = asbWithDrawalParcentage3.filter((item) => Number(WithdrawalPercentageThree) === Number(item.id))
    if (withdrawalPercentage3.length > 0) formRef.$("withdrawal-parcentage-3").set("value", withdrawalPercentage3[0])


}

export default initialDefaults